<template>
  <div class="app-licenses">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${options.componentKey}-${i}`"
        class="input-group">
          <el-checkbox
            @change="clearError('emptyContractAgreement', i)"
            v-model="valueLocal[i].smartContractAgreement">
            <div class="smart-contract-agreement">
              {{ options.descriptionforced }}
            </div>
          </el-checkbox>
          <div v-if="error[i].emptyContractAgreement" class="ait_message ait_message--error">
            {{ error[i].emptyContractAgreement }}</div>

          <el-select
            :disabled="!valueLocal[i].smartContractAgreement"
            v-model="valueLocal[i].Licenses"
            :key="`app-licenses-opt-${i}`"
            :filterable="typeof options.filterable !== 'undefined' ? options.filterable : false"
            :clearable="typeof options.clearable !== 'undefined' ? options.clearable : true"
            @focus="clearError('emptyLicense', i)"
            @visible-change="onVisibleChange"
            :class="{ 'child-has-error': error[i].emptyLicense }"
            v-bind="widgetOptions">
            <el-option
              v-for="(label, value, j) in options.options"
              class="select-option license-option_lio"
              :key="`app-licenses-opt-option-${j}`"
              :label="label"
              :value="value">
              <img :src="licenses[value].icon" class="lio_icon">
              <div class="lio_label">{{ label }}</div>
              <div class="lio_desc">
                {{ options.optionsDescriptions[value] }}</div>
            </el-option>
          </el-select>
          <div v-if="error[i].emptyLicense" class="ait_message ait_message--error">
            {{ error[i].emptyLicense }}</div>

          <template v-if="licenseTerms">
            <div class="input-subtitle">{{ licenseTerms.Title }}</div>
            <el-select
              @focus="clearError('emptyLicenseTerms', i)"
              :disabled="!valueLocal[i].smartContractAgreement"
              v-model="valueLocal[i].LicensesTerms"
              class="license-terms-select"
              multiple
              clearable
              :class="{ 'child-has-error': error[i].emptyLicenseTerms }"
              placeholder="Выберите варианты использования...">
              <el-option
                v-for="(label, value, j) in licenseTerms.WidgetOptions.Options"
                :key="`app-select-license-terms-${j}`"
                :label="label"
                :value="value">
              </el-option>
            </el-select>
            <div v-if="error[i].emptyLicenseTerms" class="ait_message ait_message--error">
              {{ error[i].emptyLicenseTerms }}</div>
          </template>

          <template v-if="licenseInformation">
            <div class="input-subtitle">{{ licenseInformation.Title }}</div>
            <el-input
              @focus="clearError('emptyLicenseInformation', i)"
              :disabled="!valueLocal[i].smartContractAgreement"
              v-model="valueLocal[i].LicensesInformation"
              :type="licenseInformation.Widget"
              :rows="licenseInformation.WidgetOptions.Rows"
              :class="{ 'child-has-error': error[i].emptyLicenseInformation }"
              :key="`licenses-information-${i}`"/>
            <input-example
              :key="`licenses-information-example-${i}`"
              :example="licenseInformation.Example"/>
            <div v-if="error[i].emptyLicenseInformation" class="ait_message ait_message--error">
              {{ error[i].emptyLicenseInformation }}</div>
          </template>

          <input-example
            :key="`input-example-${options.componentKey}-${i}`"
            :example="options.example"/>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import licenses from '@/data/licenses';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: {
        smartContractAgreement: false,
        Licenses: '',
        LicensesTerms: '',
        LicensesInformation: '',
      },
      errorBase: {
        emptyContractAgreement: '',
        emptyLicense: '',
        emptyLicenseTerms: '',
        emptyLicenseInformation: '',
      },
      loading: false,
      curIndex: 0,
      licenses,
      licenseTerms: '',
      licenseInformation: '',
      showLicenseTerms: false,
    };
  },

  watch: {
    smartContractAgreement: {
      handler() {
        if (this.valueLocal[this.curIndex].smartContractAgreement === true &&
        !this.valueLocal[this.curIndex].Licenses &&
        this.options.defaultvalue) {
          this.valueLocal[this.curIndex].Licenses = this.options.defaultvalue;
        } else if (this.valueLocal[this.curIndex].smartContractAgreement === false) {
          this.valueLocal[this.curIndex].Licenses = '';
          this.widgetOptions.placeholder = 'Выберите тип лицензии...';
        }
      },
    },
  },

  created() {
    this.error.push(this.errorBase);
    this.validateMessages = Object.assign(
      this.validateMessages, {
        emptyContractAgreement: 'Заполните согласие на предоставление доступа к объекту',
        emptyLicense: 'Выберите тип лицензии',
        emptyLicenseTerms: 'Выберите разрешенные варианты использования',
        emptyLicenseInformation: 'Заполните дополнительные лицензионные условия',
      },
    );

    if (!this.options.componentKey) this.options.componentKey = 0;
    this.widgetOptions.placeholder = 'Выберите значение...';
    this.smartContractAgreement = false;
    if (this.options.LicensesTerms.WidgetOptions.Options) {
      this.licenseTerms = this.options.LicensesTerms;
    }
    if (this.options.LicensesInformation) {
      this.licenseInformation = this.options.LicensesInformation;
    }
  },

  methods: {

    clearError(elName, i) {
      if (this.error[i][elName]) {
        this.error[i][elName] = '';
        this.$forceUpdate();
      }
    },

    // Return errors array for all fields
    getError() {
      // Validate if required
      if (this.options.required) {
        this.valueLocal.forEach((el, i) => {
          this.error[i] = {
            emptyContractAgreement: '',
            emptyLicense: '',
            emptyLicenseTerms: '',
            emptyLicenseInformation: '',
          };
          if (!el.smartContractAgreement) {
            this.error[i].emptyContractAgreement = this.validateMessages.emptyContractAgreement;
            return;
          }
          if (!el.Licenses) {
            this.error[i].emptyLicense = this.validateMessages.emptyLicense;
          }
          if (this.licenseTerms.Required && el.LicensesTerms.length === 0) {
            this.error[i].emptyLicenseTerms = this.validateMessages.emptyLicenseTerms;
          }
          if (this.licenseInformation.Required && !el.licenseInformation) {
            this.error[i].emptyLicenseInformation = this.validateMessages.emptyLicenseInformation;
          }
        });
      }
      this.updateValue();
      return this.error;
    },

    getValue() {
      const vl = this.valueLocal;
      const r = [];
      vl.forEach((v) => {
        r.push({
          Licenses: v.Licenses,
          LicensesTerms: v.LicensesTerms,
          LicensesInformation: v.LicensesInformation,
        });
      });
      if (this.options && this.options.multiple) {
        return r;
      }
      return r.length ? r[0] : null;
    },

    setValue(value) {
      value = Array.isArray(value) ? value : [value];
      this.valueLocal = [];
      value.forEach((v, i) => {
        this.valueLocal.push({
          Licenses: v.Licenses ? v.Licenses : '',
          LicensesTerms: v.LicensesTerms ? v.LicensesTerms : '',
          LicensesInformation: v.LicensesInformation ? v.LicensesInformation : '',
          smartContractAgreement: v.Licenses ? true : '',
        });
        this.error[i] = this.errorBase;
      });
      this.$forceUpdate();
    },

    onVisibleChange(isVisible) {
      if (isVisible) {
        const width = this.$el.offsetWidth;
        document.querySelectorAll('.select-option').forEach((el) => {
          el.style.width = `${width}px`;
        });
      }
    },

  },

};
</script>

<style lang="scss">
.app-licenses {
  .ait_message {
    margin-bottom: 10px;
  }
  .input-subtitle {
    padding-top: 20px;
  }
  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner {
    background: rgba(0, 0, 0, 0.1);
  }
}
.license-option_lio {
  position: relative;
  padding: 10px 20px 10px 70px !important;
  min-height: 75px;
  .lio_icon {
    position: absolute;
    left: 16px;
    top: 10px;
    width: 42px;
    height: auto;
    display: block;
  }
  .lio_label {
    font-weight: bold;
    line-height: 17px;
    margin-bottom: 5px;
  }
  .lio_desc {
    line-height: 17px;
  }
  @media (max-width: 550px) {
    padding: 10px 20px 10px 20px !important;
    .lio_icon {
      position: static;
      margin-right: 10px;
      float: left;
      width: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppLicenses.vue